import React from "react";
import "./index.css";
const success_img = require("../../../assets/media/photos/social.png");
class SuccessModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div
        className="modal fade"
        id="success"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content modal success_modal">
            <img src={success_img} width="60" alt="icon" />
            <p>
              Congratulations your poll has been submitted. Your community will
              now be invited to answer your question.
            </p>
          </div>
        </div>
      </div>
    );
  }
}
export default SuccessModal;



// WEBPACK FOOTER //
// ./src/screens/Polls/components/SuccessModal.js